<template>
  <path
    d="M12 22.0002C17.5228 22.0002 22 17.523 22 12.0002C22 6.47734 17.5228 2.00018 12 2.00018C6.47715 2.00018 2 6.47734 2 12.0002C2 17.523 6.47715 22.0002 12 22.0002Z"
  />
</template>
